import * as React from 'react';
import Page from 'components/Page';
import { Button, Row, Col, Input, Label, FormGroup } from 'reactstrap';
//import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/lib/md';
//import bgimage from '../assets/img/icon/ms-excel.png';
//import ReactExport from "react-data-export";
import { connect } from 'react-redux';
import * as loginSelectors from 'store/login/reducer';
import TablePlaque from '../components/TablePlaque';
//import BaseService from '../services/BaseService';

/* const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet; */

class HistoryTransation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            date_from: this.returnDate(),
            date_to: this.returnDate("to"),
            plaque: '',
            plaque_invalid: false,
            show_form_route: false,
            show_deleting: false,
            dateFrom: false,
            dateTo: false,
            isBuy: false,
            isCredit: false,
            isParking: false,
            isPlaque: false,
            columns: [
                { name: 'id', title: 'ID' },
                { name: 'date_parking', title: 'Data' },
                { name: 'operator', title: 'Operador' },
                { name: 'credits', title: 'Utilização de Crédito', getCellValue: row => (row.credits.length > 0 ? row.credits : 'Indisponivel') },
                { name: 'status', title: 'Status do Estacionameno' },
                { name: 'document', title: 'Documento' }
            ],
            columns_credit: [
                { name: 'id', title: 'ID' },
                { name: 'type', title: 'Utilização de Crédito' },
                { name: 'value', title: 'Valor' }
            ],
            columns_parking: [
                { name: 'id', title: 'ID' },
                { name: 'type', title: 'Estacionamento' },
                { name: 'value', title: 'Tipo' }
            ],
            exportData: [],
            reload: false,
            editingObj: null,
            delete_id: -1
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onPlaque = this.onPlaque.bind(this);
    }
    componentDidMount() {

    }
    onPlaque() {
        if(this.state.plaque.length > 3){
            this.setState({
                isPlaque: true,
                reload: !this.state.reload,
                plaque_invalid: false
            });
        }
        else{
            this.setState({
                plaque_invalid: true
            });
        }
    }
    returnDate(type) {var da = new Date();
        var mounth = da.getMonth() + 1;
        var year = da.getFullYear();
        var data = new Date(year, mounth, 0);
        var day = data.getDate();
        if (da.getMonth() + 1 < 10) {
            mounth = "0" + (da.getMonth() + 1);
        }
        if (type === "to") {
            return year + "-" + mounth + "-" + day;
        } else {
            day = "01";
            return year + "-" + mounth + "-" + day;
        }
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value,
        });
    }

    returnApi = () => {
        var date1 = this.state.date_from;
        var date2 = this.state.date_to;
        date1 = date1.replace("/", "-").replace("/", "-");
        date2 = date2.replace("/", "-").replace("/", "-");
        var date = "admin/statistics/plate-history?ini_date=" + date1 + "&end_date=" + date2 + "&plate="+this.state.plaque + "&document="+this.state.document
        return date
    }
    render() {
        return (
            <Page
                title="Historico"
                className="UserAdviserPage"
                style={{
                    minHeight: '84vh'
                }}>
                <style>{"\
                    td {\
                        max-width: 400px;\
                        overflow: hidden;\
                        text-overflow: ellipsis;\
                        white-space: nowrap;\
                    }\
                "}</style>
                {/* <Row>
                    <Col sm={3}>
                        <ExcelFile element={<Button outline><img src={bgimage} alt="excel" /> Exportar para Excel</Button>}>
                            <ExcelSheet dataSet={this.getResults()} name="Employees">
                            </ExcelSheet>
                        </ExcelFile>
                        <br />
                    </Col>
                </Row> */}
                <Row>
                    <Col sm={3} >
                        <FormGroup>
                            <Label >Placa: </Label>
                            <Input
                                type="text"
                                maxLength={10}
                                name="plaque"
                                value={this.state.plaque}
                                onChange={this.handleInputChange}
                                invalid={this.state.plaque_invalid}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={3} >
                        <FormGroup>
                            <Label >CPF/CNPJ: </Label>
                            <Input
                                type="text"
                                maxLength={18}
                                name="document"
                                value={this.state.document}
                                onChange={this.handleInputChange}
                                // invalid={this.state.plaque_invalid}
                            ></Input>
                        </FormGroup>
                    </Col>                     
                    <Col sm={2} >
                        <FormGroup>
                            <Label >De: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_from"
                                value={this.state.date_from}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateFrom}
                                max={this.state.date_to}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={2}   >
                        <FormGroup>
                            <Label>Até: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_to"
                                value={this.state.date_to}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateTo}
                                min={this.state.date_from}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={2}>
                        <br />
                        <Button
                            outline
                            onClick={this.onPlaque}
                            style={{
                                marginTop: '7px'
                            }}
                        > Procurar</Button>
                    </Col>
                </Row>
                <div hidden={!this.state.isPlaque}>
                    <Row>
                        <FormGroup style={{ marginLeft: 32, width: '95%' }}>
                            <Row>
                                {/* <Label style={{margin: 0}}>Compra &nbsp;</Label> */}
                                {/* <Button style={{padding: 0}} onClick={() => this.setState({ isBuy: !this.state.isBuy })}> {this.state.isBuy === true ? <MdArrowDropUp size={25} /> : <MdArrowDropDown size={25} />} </Button> */}
                                <Col sm={12} md={12} lg={12}>
                                        <br/>
                                        <TablePlaque
                                            api={this.returnApi()}
                                            route="true"
                                            hideButton={true}
                                            user={this.props.user}
                                            columns={this.state.columns}
                                            dateFilter="false"
                                            integratedFilter="false"
                                            currencyColumns="false"
                                            showPagingState="false"
                                            filterState="false"
                                            integratePag="false"
                                            reload={this.state.reload}
                                        />
                                    {/* <Collapse isOpen={this.state.isBuy}>
                                    </Collapse> */}
                                </Col>
                            </Row>
                        </FormGroup>
                    </Row>
                    {/* <Row>
                        <FormGroup style={{ marginLeft: 32, width: '95%' }}>
                            <Row>
                                <Label style={{margin: 0}}>Utilização de Créditos &nbsp;</Label>
                                <Button style={{padding: 0}} onClick={() => this.setState({ isCredit: !this.state.isCredit })}> {this.state.isCredit === true ? <MdArrowDropUp size={25} /> : <MdArrowDropDown size={25} />} </Button>
                                <Col sm={12} md={12} lg={12}>
                                    <Collapse isOpen={this.state.isCredit}>
                                        <br/>
                                        <TablePlaque
                                            api={this.returnApi()}
                                            route="true"
                                            hideButton={true}
                                            user={this.props.user}
                                            columns={this.state.columns_credit}
                                            dateFilter="false"
                                            integratedFilter="false"
                                            currencyColumns="false"
                                            showPagingState="false"
                                            filterState="false"
                                            integratePag="false"
                                            reload={this.state.reload}
                                        />
                                    </Collapse>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Row>
                    <Row>
                        <FormGroup style={{ marginLeft: 32, width: '95%' }}>
                            <Row>
                                <Label style={{margin: 0}}>Estacionamentos irregular/regular &nbsp; </Label>
                                <Button style={{padding: 0}} onClick={() => this.setState({ isParking: !this.state.isParking })}> {this.state.isParking === true ? <MdArrowDropUp size={25} /> : <MdArrowDropDown size={25} />} </Button>
                                <Col sm={12} md={12} lg={12}>
                                    <Collapse isOpen={this.state.isParking}>
                                        <br/>
                                        <TablePlaque
                                            api={this.returnApi()}
                                            route="true"
                                            hideButton={true}
                                            user={this.props.user}
                                            columns={this.state.columns_parking}
                                            dateFilter="false"
                                            integratedFilter="false"
                                            currencyColumns="false"
                                            showPagingState="false"
                                            filterState="false"
                                            integratePag="false"
                                            reload={this.state.reload}
                                        />
                                    </Collapse>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Row> */}
                </div>
            </Page>
        );
    }
};


// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
    const currentUser = loginSelectors.getUser(state);
    return {
        user: currentUser
    };
}
export default connect(mapStateToProps)(HistoryTransation)


// WEBPACK FOOTER //
// ./src/pages/HistoricoPlaca.js